import { render, staticRenderFns } from "./newMemberGroup.vue?vue&type=template&id=58563201&scoped=true&"
import script from "./newMemberGroup.vue?vue&type=script&lang=js&"
export * from "./newMemberGroup.vue?vue&type=script&lang=js&"
import style0 from "./newMemberGroup.vue?vue&type=style&index=0&id=58563201&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58563201",
  null
  
)

export default component.exports